import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ParentescoService {
  private apiUrl =  `${environment.apiUrl}/api/parentescos`; 
 // private apiUrl = 'http://localhost:3000/api/parentescos';

  constructor(private http: HttpClient) {}

  getParentescos(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl).pipe(
      catchError(error => {
        console.error('Error al obtener registros de parentesco:', error);
        return throwError(() => new Error('Error al obtener registros de parentesco'));
      })
    );
  }
}
